/**
 *
 * @notice ContrattiModalSlice to handle state of ContrattiModal globally.
 *
 * @dev This module contains the reducer configuration and its initialization.
 * @dev Is the sucker wich contains features of this slice.
 *
 */

// Redux.
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
// Axios.
import axios from "axios"
// gmapi.
import {
    API_KEY,
    caricaFileMacchinariAPI,
    downloadCorsoLavoratoreAPI,
    downloadFileMacchinariAPI
} from "../../../common/gmApi"
// cookie.
import { tkbox, getCookie } from "../../../common/cookie"
import { downloadDocument, showDocument } from "../../../common/util"
import { downloadEmployeeCourseDocById, showEmployeeCourseDocById } from "../generale/organico/OrganicoSlice"
import { useState } from "react"

/**
 *
 *  @dev Insert a new machine.
 *
 */
export const addFile = createAsyncThunk(
    // Action route.
    "manutenzioni/addFile",
    async ({ idBoxMacchinari, descrizione, dataCaricamento, dataScadenza, allegato, tipo }, thunkAPI) => {
        try {

            var bodyFormData = new FormData()
            bodyFormData.append('allegato', allegato, allegato.name)

            const response = await axios.post(
                // url.
                caricaFileMacchinariAPI,
                // body.
                bodyFormData,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_macchinari: idBoxMacchinari,
                        descrizione: descrizione,
                        data_caricamento: dataCaricamento,
                        data_scadenza: dataScadenza,
                        tipo: tipo,
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    //return console.log(response.data);
                    return response.data
                } else {
                    // else reject gmapi response error.
                    //console.error('Error "showEmployeeCourseDocById":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "uploadVisita":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            // If something get wrong then reject the error.
            console.error('Error "uploadVisita":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)

export const showMachineFileById = createAsyncThunk(
    // Action route.
    "organico/showMachineFileById",
    async ({ idBoxDocumentiMacchinari, docName }, thunkAPI) => {
        try {
            const response = await axios.get(
                // url.
                downloadFileMacchinariAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_documenti_macchinari: idBoxDocumentiMacchinari,
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    return response
                } else {
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)

export const downloadMachineFileById = createAsyncThunk(
    // Action route.
    "organico/downloadMachineFileById",
    async ({ idBoxDocumentiMacchinari, docName }, thunkAPI) => {
        try {
            const response = await axios.get(
                // url.
                downloadFileMacchinariAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_documenti_macchinari: idBoxDocumentiMacchinari,
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    // Build a custom response with extradata.
                    return {
                        data: response.data,
                        eventSender: idBoxDocumentiMacchinari,
                    }
                } else {
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)
/**
 *
 *  @dev Create "FileManutenzioniModalSlice" feature.
 *
 */
export const fileManutenzioniModalSlice = createSlice({
    // Name, used in action types.
    name: "manutenzioniModal",
    // The initial state for the reducer.
    initialState: {
        modalIsOpen: false,     // Modal is open or not.
        modalIsFetching: false, // AsyncThunk is calling an API.
        modalIsSuccess: false,  // AsyncThunk is success from API call.
        modalIsError: false,    // AsyncThunk is fail from API call.
        modalErrorMsg: "",      // Error message container.
        files:[],
        file: [],
        type: '',
    },
    // Reducers, an object of "case reducers".
    // Key names will be used to generate actions.
    reducers: {
        clearState: (state) => {
            state.modalIsError = false
            state.modalIsSuccess = false
            state.modalIsFetching = false

            return state
        },
        openModal: (state, action) => {
            state.type = action.payload;
            state.modalIsOpen = true
        },
        closeModal: (state) => {
            state.modalIsOpen = false
        },
        setType: (state, action) => {
            state.type = action.payload;
            return state;
        },
        cleanUpFiles: (state) => {
            state.files = []
            return state
        },
    },
    // AsyncThunk Reducers.
    // A "builder callback" function used to add more reducers, or
    // an additional object of "case reducers", where the keys should be other
    // action types.
    extraReducers: (builder) => {
        builder
            .addCase(addFile.fulfilled, (state, action) => {
                state.modalIsFetching = false
                state.modalIsSuccess = true
                state.files =  action.payload.gmapi.response.data
            })
            .addCase(addFile.pending, (state) => {
                state.modalIsFetching = true
            })
            .addCase(addFile.rejected, (state, action) => {
                state.modalIsFetching = false
                state.modalIsError = true
                state.modalErrorMsg = action.payload
            })

            .addCase(showMachineFileById.fulfilled, (state, action) => {
                state.file = action.payload.data.gmapi.response.data
                showDocument(state.file)
            })


            .addCase(downloadMachineFileById.fulfilled, (state, action) => {
                state.isFetchingCourseDoc = false
                state.isSuccessCourseDoc = true

                state.file = action.payload.data.gmapi.response.data
                state.fileName = action.meta.arg.docName
                downloadDocument(state.file, state.fileName)
            })

    },
})

// Export the reducer.
export const { clearState, openModal, closeModal, setType, cleanUpFiles } = fileManutenzioniModalSlice.actions

// Export the Slice by name.
export const fileManutenzioniModalSelector = (state) => state.fileMenutenzioniModal
